import { render, staticRenderFns } from "./step-card.vue?vue&type=template&id=77837d60&scoped=true"
import script from "./step-card.vue?vue&type=script&lang=js"
export * from "./step-card.vue?vue&type=script&lang=js"
import style0 from "./step-card.vue?vue&type=style&index=0&id=77837d60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77837d60",
  null
  
)

export default component.exports